var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5C13.3125 11.5 12 13.0938 12 15C12 16.9375 13.3125 18.5 15 18.5C16.6562 18.5 18 16.9375 18 15C18 13.0938 16.6562 11.5 15 11.5ZM15 17.5C13.875 17.5 13 16.4062 13 15C13 13.625 13.875 12.5 15 12.5C16.0938 12.5 17 13.625 17 15C17 16.4062 16.0938 17.5 15 17.5ZM24.4062 8.71875C23.1875 8.21875 21.9688 8 20.75 8C16.9062 8 13.0625 9.96875 9.21875 9.96875C7.1875 9.96875 6.4375 9.46875 6 9.46875C5.46875 9.46875 5 9.90625 5 10.4688V20.4062C5 20.7812 5.21875 21.1562 5.5625 21.3125C6.78125 21.8125 8 22 9.21875 22C13.0625 22 16.9062 20.0625 20.75 20.0625C22.7812 20.0625 23.5312 20.5312 23.9688 20.5312C24.5 20.5312 25 20.125 25 19.5625V9.625C25 9.25 24.75 8.875 24.4062 8.71875ZM6 10.5C6.65625 10.6875 7.28125 10.8125 7.96875 10.9062C7.90625 11.9375 7.0625 12.7812 6 12.7812V10.5ZM6 20.4062V19.0625C7.03125 19.0625 7.90625 19.875 7.96875 20.9062C7.28125 20.8125 6.59375 20.6562 6 20.4062ZM23.9688 19.5312C23.3125 19.3438 22.6875 19.2188 22 19.125C22.0938 18.125 22.9375 17.3125 23.9688 17.3125V19.5312ZM23.9688 16.3125C22.4062 16.3125 21.125 17.5312 21 19.0625C18.8125 19.0312 16.7188 19.5625 14.75 20.0625C12.4062 20.6562 10.7812 21.0312 8.96875 21C8.9375 19.375 7.625 18.0625 6 18.0625V13.7812C7.59375 13.7812 8.875 12.5312 8.96875 10.9688C11.1562 11 13.25 10.4688 15.2188 9.96875C17.5625 9.375 19.1875 9 21 9.03125C21 10.6875 22.3438 12.0312 23.9688 12.0312V16.3125ZM23.9688 11.0312C22.9062 11.0312 22.0312 10.1875 22 9.125C22.6875 9.21875 23.375 9.375 24 9.625L23.9688 11.0312Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.6e6b5ba5.svg";
export { ForwardRef as ReactComponent };